<!-- =========================================================================================
  File Name: DataListThumbView.vue
  Description: DataList Thumb View
  ----------------------------------------------------------------------------------------
  Item Name: BCC Pubs
    Author: Johnny Palmer
  Author URL: http://sweetas.xyz
========================================================================================== -->

<template>
  <div id="thumb-view" class="data-list-container pt-5">

    <sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />

    <vs-table ref="table" v-model="selected" pagination :max-items="itemsPerPage" search  :data="products">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow">       
        
        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 justify-left">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ products.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : products.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
        <div class="justify-right">  
          <ul class="switch-container">
            <li>
              <label>Images</label>
              <vs-switch v-model="imgShow" />
            </li>
          </ul>
        </div>
      </div>

      <template slot="thead">
        <vs-th v-if="imgShow" class="w-1/12" ></vs-th>
        <vs-th sort-key="name" :class ="imgShow ? 'w-2/3' : 'w-3/4'"></vs-th>
         <vs-th class="w-1/12 text-center"></vs-th>
        <vs-th sort-key="price" class="w-1/12 text-center"></vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="tr.sku" v-for="tr in data">

            <vs-td v-if="imgShow" class="img-container w-1/12">
              <img v-if="tr.image.indexOf('http') >= 0" :src="tr.image"  class="product-img"/>
              <img v-if="tr.image==''" src="@/assets/images/pages/no-image.png" class="product-img-stock"/>
              <img v-if="tr.image!='' && tr.image.indexOf('http') < 0" :src="require(`@/assets/images/bcc/${tr.image}`)" class="product-img"/>
            </vs-td>
            <vs-td :class ="imgShow ? 'w-2/3' : 'w-3/4'">
               <div class="my-4">
                    <h4 class="truncate font-semibold mb-1 hover:text-primary cursor-pointer" 
                    :class="`${tr.stock== 0 ? 'text-strikethough' : ''}`"
                    >{{ tr.name }}</h4>
                    <p class="item-description truncate text-sm text-primary">sku {{ tr.sku}}</p>
                </div>
            </vs-td>
            <vs-td class="w-1/12"> 
              <div class="py-1 px-2  mt-1 text-center">
                  <span class="text-sm mr-1 font-bold no-wrap"><small> Available </small>: {{ limitStockMin(tr.stock) }}</span>
              </div>      
            </vs-td>

            <vs-td class="w-1/12 "> 
              <div class = "mt-4" v-if="isInCart(tr.sku)">
                <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-shopping-cart"  @click="cartView" class="no-wrap">VIEW IN CART</vs-button>
              </div>
              <template class ="text-center mt-4 w-full" v-else>
                <vs-button v-if="tr.stock > tr.lowstock" color="success" type="filled" icon-pack="feather" icon="icon-shopping-cart"  
                @click="cartAdd(tr)" class="no-wrap">ADD TO CART</vs-button>

                <vs-button v-if="tr.stock <= tr.lowstock && tr.stock > 0" color="warning" type="filled" icon-pack="feather" icon="icon-shopping-cart"  
                @click="cartAdd(tr)" class="no-wrap">ADD TO CART</vs-button>

                <vs-button v-if="tr.stock <= 0" color="danger" type="filled" icon-pack="feather" icon="icon-x" disabled  
                @click="cartAdd(tr)" class="no-wrap">OUT OF STOCK</vs-button>                               
              </template>            
            </vs-td>  
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import Sidebar from './Sidebar.vue'
export default {
  props: ['ipid'],
  components: {
    Sidebar
  },
  data () {
    return {
      imgShow:false,
      products:[],
      selected: [],
      itemsPerPage: 10,
      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {},
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {   
      return this.$refs.table !== undefined 
      && this.$refs.table.queriedResults !== undefined  ? this.$refs.table.queriedResults.length : this.products.length
    },
    isInCart () {      
      return itemId => this.$store.getters['eCommerce/isInCart'](itemId)
    }
  },
  methods: {
    limitStockMin (e) {
      return (e < 0) ? 0 : e
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    additemInCart (item) {
      this.$store.dispatch('eCommerce/additemInCart', item)
      
      this.$vs.notify({
        text: `${item.name } added to Cart`,
        color: 'success',
        iconPack: 'feather',
        icon:'icon-check'
      })

    },
    cartView () {      
      this.$router.push('/cart').catch(() => {}) 
    },
    cartAdd (item) {      
      
      this.additemInCart(item)
    }
  },
  created () {
    
    const appLoading = document.getElementById('loading-bg').style.display === 'block'

    if (!appLoading) {
      document.getElementById('loading-bg').style.display = 'block' 
    }

    const iip = this.$store.state.eCommerce.ipid
    if (iip === undefined 
    || iip === '' 
    || iip !== this.$route.params.ipid) {   
      const payload = {IpId: iip}       
      this.$store.dispatch('eCommerce/updateIpId', payload)   
    }   
    
    const p  = { IpId: this.$store.state.eCommerce.ipid, StockAlert: 1 }
    this.$store.dispatch('dataList/getAddressDetails', p)
    
    this.$store.dispatch('dataList/getProducts', p).then(() => {
      this.products = this.$store.state.dataList.products          
      document.getElementById('loading-bg').style.display = 'none'       
    })
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
.no-wrap{white-space: nowrap!important;}
#thumb-view {
  .vs-con-table {

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;
      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 10px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
            &.img-container {             
              span {
                display: flex;
                justify-content: flex-start;
              }

              .product-img {
                height: 128px!important;
                width:90px!important;
              }
              .product-img-stock{
                height: 64px!important;
              }
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
  .text-center .vs-table-text{
    display:inline!important;
  }
  .text-strikethough{
    text-decoration: line-through;
  }
}
</style>
